import React from 'react';
import UploadManager from 'components/UploadManager';

const ActivityUploads = () => <UploadManager
  uploadType="activity_uploads"
  title="Activity"
/>;

export default ActivityUploads;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/activityUploads/index.jsx